import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeSevenComponent } from './components/pages/home-seven/home-seven.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { CountersComponent } from './components/pages/counters/counters.component';
import { CountdownsComponent } from './components/pages/countdowns/countdowns.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ShowCaseComponent } from './components/pages/show-case/show-case.component';
import { PricingsComponent } from './components/pages/pricings/pricings.component';
import { RhillaneComponent } from './components/pages/websites/rhillane.component';
import { PubliciteComponent } from './components/pages/publicite/publicite.component';
import { ReseauxSociauxComponent } from './components/pages/reseaux-sociaux.component';
import { DesignGraphiqueComponent } from './components/pages/design-graphique.component';
import { SeoAgenceComponent } from './components/pages/seo-agence.component';
import { AProposComponent } from './components/pages/apropos-nous.component';
import { ContactezNousComponent } from './components/pages/contactez-nous.component';
import { CguComponent } from './components/pages/cgu.component';
import { PolitiqueConfidentialiteComponent } from './components/pages/politique-confidentialite.component';
import { DevisComponent } from './components/pages/devis.component';
import { appwebComponent } from './components/pages/appweb/appweb.component';

const routes: Routes = [
  {
    path: '',
    component: HomeSevenComponent,
    title: "Digital Alchemy"
  },
  {
    path: 'home-seven',
    component: HomeSevenComponent
  },
  {path: 'blog', component: BlogComponent},
  {path: 'blog-details', component: BlogDetailsComponent},
  {path: 'counters', component: CountersComponent},
  {path: 'countdowns', component: CountdownsComponent},
  {path: 'pricings', component: PricingsComponent},
  {path: 'error', component: ErrorComponent},
  {path: 'coming-soon', component: ComingSoonComponent},
  {path: 'show-case', component: ShowCaseComponent},
  {
    path: 'web',
    component: RhillaneComponent
  },
  {path: 'publicite', component: PubliciteComponent},
  {path: 'gestion', component: ReseauxSociauxComponent},
  {path: 'design', component: DesignGraphiqueComponent},
  {path: 'agence', component: SeoAgenceComponent},
  {path: 'apropos', component: AProposComponent},
  {path: 'contact', component: ContactezNousComponent},
  {path: 'cgu', component: CguComponent},
  {path: 'conf', component: PolitiqueConfidentialiteComponent},
  {path: 'devis', component: DevisComponent},
  {path: 'appweb', component: appwebComponent},
  {path: '**', component: ErrorComponent}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 0]
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }